import { FileImage, FileText } from 'lucide-react';

export function MaterialIcon({ mimeType }: { mimeType: string }) {
  return mimeType.startsWith('image/') ? (
    <FileImage className="h-5 w-5" aria-hidden="true" />
  ) : (
    <FileText className="h-5 w-5" aria-hidden="true" />
  );
}
